<div *ngIf="visible"
  [id]="id"
  class="dynamic-input ion-margin-bottom"
  [ngClass]="[
    !!tooltip ? 'dynamic-input--with-tooltip' : '',
    !!cssClass ? cssClass : ''
  ]">
  <div *ngIf="!!title" class="dynamic-input-label">
    <h4 class="field-title"
      [attr.aria-label]="title | ariaLabel: skipAriaTitleAdaptation | translate"
      [innerHTML]=" (title | translate) + (required && !hideMandatorySign ? '*' : '')">
    </h4>
    <ion-button *ngIf="!!tooltip"
      [attr.aria-label]="id + '_tooltip' | ariaLabel | translate"
      fill="clear"
      color="secondary"
      class="tooltip-btn ion-no-margin"
      (click)="openTooltip($event)">
      <ion-icon slot="icon-only" [src]="'information' | srcAssets"></ion-icon>
    </ion-button>
  </div>
  <ng-content></ng-content>
</div>
